import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { IconsModule, LoadingDotsModule } from '../../core-ui';
import { PageLayoutsModule } from '../../page-layouts';
import { CoreUiModule } from '../core-ui.module';
import { AccountSubscriptionManagerPage } from './account-subscription-manager.page';
import { AccountSubscriptionActivationsComponent } from './overview-page/activations/activations.component';
import { VMValuePipe } from './overview-page/activations/vm-value.pipe';
import { AccountSubscriptionManagerBillingContactComponent } from './overview-page/billing-contact/billing-contact.component';
import { AccountSubscriptionManagerConsultantContactComponent } from './overview-page/consultant-contatct/consultant-contact.component';
import { ContractRenewalDateComponent } from './overview-page/contract-renewal-date/contract-renewal-date.component';
import { AccountSubscriptionManagerOverviewComponent } from './overview-page/overview.component';
import { SubscriptionPlansComponent } from './overview-page/subscription-plans/subscription-plans.component';
import { TransactionTableComponent } from './overview-page/transaction-table/transaction-table.component';
import { TransactionTableEmptyComponent } from './overview-page/transaction-table-empty/transaction-table-empty.component';

@NgModule({
    declarations: [
        AccountSubscriptionManagerPage,
        AccountSubscriptionManagerOverviewComponent,
        AccountSubscriptionActivationsComponent,
        AccountSubscriptionManagerBillingContactComponent,
        AccountSubscriptionManagerConsultantContactComponent,
        SubscriptionPlansComponent,
        ContractRenewalDateComponent,
        TransactionTableComponent,
        TransactionTableEmptyComponent,
        VMValuePipe
    ],
    imports: [
        CommonModule,
        PageLayoutsModule,
        RouterModule,
        MatTableModule,
        MatSortModule,
        IconsModule,
        LoadingDotsModule,
        CoreUiModule
    ]
})
export class AccountSubscriptionManagerModule {}
